<template>
  <div>
    <BookingNotValidAlert v-if="booking_validation && !booking_validation.status"
      :booking_validation="booking_validation">
    </BookingNotValidAlert>
    <BookingAvailabilityAlert v-if="booking_availability && !booking_availability.status"
      :booking_availability="booking_availability">
    </BookingAvailabilityAlert>


    <v-container class="pt-0 pb-5" v-if="show_cart">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <div class="d-flex justify-start" v-if="!show_payment_form">

              <SportipsButton v-if="!mainStore.dossard_bourse_mode" toPage="Inscriptions" chevronLeft> Retour aux
                inscriptions
              </SportipsButton>
              <SportipsButton v-else @onClick="goback" chevronLeft> Retour aux inscriptions </SportipsButton>
            </div>
            <v-divider></v-divider>
            <!-- Formulaire de connexion au compte Sportips -->
            <div v-if="!mainStore.inscription_as_admin">
              <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                  size="xs-small"></v-icon> {{ account_wording[0] }} Sportips</h4>
              <div v-if="mainStore.authUser.isLogged">Connecté en tant que {{ mainStore.authUser.userMail }}</div>
              <v-row v-else>
                <v-col md="6" cols="12">
                  <LoginForm></LoginForm>
                </v-col>
              </v-row>
            </div>

            <!-- Formulaire de paiement lors d'une commande admin -->
            <ModalitePaiementAdmin v-if="mainStore.inscription_as_admin" @onPostAdmin="handle_admin_checkout">
            </ModalitePaiementAdmin>
            <!-- Formulaire de paiement lors d'une commande utilisateur -->
            <div v-else>
              <h4 class="font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                  size="xs-small"></v-icon> Récapitulatif de ma commande</h4>
              <v-row>
                <v-col cols="12" md="5" v-if="!show_payment_form">
                  <div class="d-flex flex-column align-start justify-stretch rounded bg-dark pa-4 mt-2">
                    <div class="d-flex justify-space-between w-100">
                      <div>Nombre de participants</div>
                      <div>
                        {{ bookingStore.inscriptions.length }}
                      </div>
                    </div>
                    <div class="d-flex justify-space-between w-100" v-if="!bookingStore.exclude_taxe">
                      <div>Sous Total</div>
                      <div v-if="bookingStore.prix > 0">{{ bookingStore.prix }}€</div>
                    </div>
                    <div class="d-flex justify-space-between w-100" v-if="!bookingStore.exclude_taxe">
                      <div>Frais de gestion</div>
                      <div>{{ bookingStore.taxe }}€</div>
                    </div>
                    <div class="d-flex justify-space-between w-100">
                      <div>Total à payer</div>
                      <div>{{ bookingStore.prix_total }}€</div>
                    </div>
                    <v-alert
                      v-if="mainStore.module.has_preinscription || bookingStore.has_at_least_one_preinscription_selected"
                      class="mt-3">
                      <div>
                        Vous vous apprêtez à procéder a un prépaiement. Vous ne serez débité qu'en cas de validation
                        de votre inscription par l'organisateur.
                      </div>
                    </v-alert>

                    <div class="w-100" v-if="mainStore.authUser.isLogged">
                      <BeforeAccessCheckout @onFreeCheckout="handle_free_checkout()"
                        @onAccessCheckout="access_checkout()"></BeforeAccessCheckout>
                    </div>
                    <div class="mt-4" v-else>
                      <v-alert>Vous devez vous connecter à votre {{ account_wording[1] }} Sportips via le formulaire
                        ci-dessus afin
                        d'accèder au paiement et valider votre inscription.</v-alert>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="5" v-else>
                  <AfterAccessCheckout @onError="onErrorCheckout"></AfterAccessCheckout>
                </v-col>
                <v-col cols="12" md="7" v-if="!show_payment_form">
                  <RecapitulatifCommande></RecapitulatifCommande>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import BookingNotValidAlert from "@/components/Checkout/Booking_Not_Valid_Alert.vue";
import RecapitulatifCommande from "@/components/Checkout/Recapitulatif_Commande.vue";
import LoginForm from "@/components/Authentification/LoginForm.vue";
import BeforeAccessCheckout from "@/components/Checkout/Before_Access_Checkout.vue";
import AfterAccessCheckout from "@/components/Checkout/After_Access_Checkout.vue";
import ModalitePaiementAdmin from "@/components/Checkout/Modalite_Paiement_Admin.vue";
import BookingAvailabilityAlert from "@/components/Checkout/Booking_Availability_Alert.vue";

export default {
  components: { BookingNotValidAlert, RecapitulatifCommande, LoginForm, BeforeAccessCheckout, AfterAccessCheckout, ModalitePaiementAdmin, BookingAvailabilityAlert },
  data() {
    return {
      booking_validation: null,
      booking_availability: { status: true, errors: [] },
      show_payment_form: false,
      errors_on_checkout: [],
      checkout_failed: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    account_wording() {
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (is_bicentenaire) {
        return ["Mon espace personnel", "espace personnel"];
      } else {
        return ["Mon compte", "compte"];
      }
    },
    show_cart() {
      return this.booking_availability && this.booking_availability.status && this.booking_validation && this.booking_validation.status;
    }

  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    onErrorCheckout(errors) {
      this.error_message_checkout = errors;
      this.booking_availability = { status: false, errors: errors };
    },

    /**
     * Handles the admin checkout process.
     *
     * @param {Object} paiement_admin - The payment details for the admin checkout.
     * @returns {Promise<void>} - A promise that resolves when the checkout process is complete.
     */
    async handle_admin_checkout(paiement_admin) {
      const post_request = await this.bookingStore.post_admin_checkout(paiement_admin);
      if (post_request) {
        this.$router.push({ name: "CheckoutAdminSuccess" });
      }
    },

    /**
     * Handles the checkout process for free booking.
     * 
     * @returns {Promise<void>} A promise that resolves when the checkout process is complete.
     */
    async handle_free_checkout() {
      const check_availabilities = await this.bookingStore.check_availabilities();
      if (!check_availabilities.status && !this.mainStore.inscription_as_admin && !this.mainStore.inscription_vip && !this.mainStore.bookingSystem?.groupe?.inscription_course_complete) {
        this.booking_availability = check_availabilities;
        return;
      }
      const post_request = await this.bookingStore.post_free_checkout();
      if (post_request) {
        this.$router.push({ name: "CheckoutSuccess" });
      }
    },

    async access_checkout() {
      const request = await this.bookingStore.show_payment_form();
      /* console.log("request", request);
      return; */
      this.show_payment_form = request.status;

      if (!request.status) {

        this.booking_availability = request;
      }
    },
  },
  async created() {
    // Dans le cas d'une bourse aux dossards, on vérifie si dossard_bourse est présent
    const isDossardBourseMode = this.bookingStore.dossard_bourse !== null;
    if (!this.bookingStore.isInitialized && !isDossardBourseMode) {
      this.$router.push({ name: "Home" });
      return;
    }
    this.booking_validation = await this.bookingStore.get_validation();
  },
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>